import { API_BASE_URL } from "../config/apiConfig"

const request = async (endpoint, options = {}) => {
  const token = localStorage.getItem("companyAuthToken")
  if (!token) throw new Error("Company-site authentication token is missing")

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...options.headers,
    },
    cache: "no-store",
  })

  let data
  try {
    data = await response.json()
  } catch (error) {
    throw new Error(`System alert API returned a non-JSON response (${response.status})`)
  }

  if (!response.ok) throw new Error(data.message || `System alert request failed (${response.status})`)
  return data
}

export const companySiteSystemAlertApi = {
  getSidebar: () => request("/sidebar"),
  listActive: () => request("/system-alerts?lifecycle=Active&page=1&limit=20"),
  get: (alertId) => request(`/system-alerts/${alertId}`),
  markRead: (alertId) => request(`/system-alerts/${alertId}/read`, { method: "PATCH" }),
}
